var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoungeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 6,
    fill: "#444444"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39854_941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9453 17.5614V20.0256H6.05469V17.5614H5V20.2381C5 21.032 5.52302 21.7059 6.24253 21.9338V23H7.29721V22.0165H20.7028V23H21.7575V21.9338C22.477 21.7059 23 21.032 23 20.2381V17.5614H21.9453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9906 18.9855V18.9709V15.0036C10.9906 14.3926 10.4953 13.8974 9.88437 13.8974H8.22246C7.61152 13.8974 7.11627 14.3927 7.11627 15.0036V18.9709V18.9855H10.9906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9547 18.9855V18.9709V15.0036C15.9547 14.3926 15.4595 13.8974 14.8485 13.8974H13.1515C12.5405 13.8974 12.0453 14.3927 12.0453 15.0036V18.9709V18.9855H15.9547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8837 18.9855V18.9709V15.0036C20.8837 14.3926 20.3885 13.8974 19.7776 13.8974H18.1157C17.5047 13.8974 17.0095 14.3927 17.0095 15.0036V18.9709V18.9855H20.8837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 11.2314C15.718 11.2314 17.1157 9.8337 17.1157 8.11572C17.1157 6.39771 15.718 5 14 5C12.282 5 10.8843 6.39771 10.8843 8.11572C10.8843 9.8337 12.282 11.2314 14 11.2314ZM13.4727 8.13506V6.47744H14.5273V8.63143L13.2595 9.72546L12.5873 8.91279L13.4727 8.13506Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39854_941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoungeIcon);
export default __webpack_public_path__ + "static/media/loungeIcon.580cc230b127cafd68ab7c65f3c6f324.svg";
export { ForwardRef as ReactComponent };